import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  Navbar,
  BottomNavbar,
  Footer,
  Error404,
  Home,
  Aboutus,
  Contactus,
  Properties,
  Jettymayfair,
} from "./routes/Routes";

import ChatBot from "./components/ChatBot/ChatBot.jsx";
import PrivateRoute from "./hooks/PrivateRoute";
import Login from "./routes/auth/login";

import AdminNavbar from "./routes/auth/AdminNavbar";
import Dashboard from "./routes/auth/dashboard";
import AdminContactus from "./routes/auth/AdminContactus.jsx";

import GoogelAnalytics from "./routes/auth/GoogelAnalytics.jsx";
import PrivacyPolicy from "./components/Documents/PrivacyPolicy.js";
import Disclaimer from "./components/Documents/Disclaimer.js";
import TermsnConditions from "./components/Documents/TermsnConditions.js";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/*", element: <Error404 /> },

  { path: "/auth/login", element: <Login /> },
  {
    path: "/auth/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/contactus",
    element: (
      <PrivateRoute>
        <AdminContactus />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/google-analytics",
    element: (
      <PrivateRoute>
        <GoogelAnalytics />
      </PrivateRoute>
    ),
  },

  { path: "/aboutus", element: <Aboutus /> },
  { path: "/contactus", element: <Contactus /> },
  { path: "/properties", element: <Properties /> },
  { path: "/properties/jettymayfair", element: <Jettymayfair /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/disclaimer", element: <Disclaimer /> },
  { path: "/terms-conditions", element: <TermsnConditions /> }
];

export function App() {
  const location = useLocation();

  // Any route that starts with "/auth" (e.g., /auth/dashboard, /auth/contactus)
  const isAuthRoute =
    location.pathname.startsWith("/auth") &&
    location.pathname !== "/auth/login";

  window.scrollTo(0, 0);

  return (
    <>
      {isAuthRoute && <AdminNavbar />}
      {!isAuthRoute && <Navbar />}

      <div className="flex flex-1">
        <div
          className={`flex-1 min-w-0 transition-all duration-300 ${
            isAuthRoute ? "mt-14 md:ml-64" : "mt-0 pb-16 md:pb-0"
          }`}
        >
          <Routes location={location} key={location.pathname}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>

          {!isAuthRoute && <Footer />}
        </div>
      </div>
      
      {!isAuthRoute && <ChatBot />}
      {!isAuthRoute && <BottomNavbar />}
    </>
  );
}

export default App;
